import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HolliSessionService } from '../services/holli-session.service';

function shouldConsiderForAuth(url: string): boolean {
  return (
    url.startsWith(environment.outlookApiBaseUrl) ||
    url.startsWith(environment.apiBaseUrl)
  );
}

function isOutlookOfficeLoginRequest(url: string, method: string): boolean {
  return method === 'POST' && url.includes('/auth/office-login');
}

function isNgrokRequest(url: string): boolean {
  return url.includes('.ngrok-free.app');
}

export const holliAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!shouldConsiderForAuth(req.url)) {
    return next(req);
  }
  if (isOutlookOfficeLoginRequest(req.url, req.method)) {
    return next(req);
  }
  const session = inject(HolliSessionService);
  const token = session.getPassportToken();
  const shouldAttachNgrokBypassHeader = isNgrokRequest(req.url);
  if (token === null || token === '') {
    if (!shouldAttachNgrokBypassHeader) {
      return next(req);
    }
    return next(
      req.clone({
        setHeaders: {
          'ngrok-skip-browser-warning': 'true',
        },
      }),
    );
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };
  if (shouldAttachNgrokBypassHeader) {
    headers['ngrok-skip-browser-warning'] = 'true';
  }

  return next(
    req.clone({
      setHeaders: headers,
    }),
  );
};
